import React, { useEffect, useState } from 'react';
import { Box, Button, Modal } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store';
import { selectCustomerById } from '../../../../../store/customers/customersSlice';
import AddCustomer from 'views/customer/AddCustomer';
import {dateObjectToString} from "../../../../../fromKotlin/nkutils";
import KartesetMobile from '../karteset';

const CustomerActionsView2 = ({}) => {
    const [open, setOpen] = useState(true);
    const [searchParams] = useSearchParams();
    const [branches, setBranches] = useState(null);
    const [kartesetOpen, setKartesetOpen] = useState(false);
    const id = searchParams.get('id'); // Extract customer ID from query params
    const navigate = useNavigate();
    const customer = useSelector((state: RootState) => selectCustomerById(state, id));
    const [customerAction, setCustomerAction] = React.useState({
        editable: false,
        open: false,
        id: ''
    });

    useEffect(() => {
        if (customer) {
            setBranches({
                name: customer.businessName,
                id: customer.businessId,
                branch: customer.nkObject?.branch,
                master: customer.id
            });
        }
    }, [customer]);

    const handleBackdropClick = (event) => {
        if (event.target.dataset.modalBackdrop) {
            setOpen(false);
        }
    };

    const handleNavigate = (id, type,date) => {
        const d = (date)? `&date=${date}` :''
        navigate(`/mobileDeliverySummary?id=${id}&type=${type}${d}`);
    };

    const handleNavigateToPricesList = (id) => {
        navigate(`/MobilePricesList?id=${id}`);
    };

    const handleDrawerClose = React.useCallback(() => {
        setCustomerAction({
            editable: false,
            open: false,
            id: ''
        });
        navigate('/customer/customer-list');
    }, []);

    const handlePrivateInfoClick = () => {
        setCustomerAction({
            editable: true,
            open: true,
            id: id
        });
        setOpen(false);
    };

    return (
        <>
            <Box
                data-modal-backdrop
                onClick={handleBackdropClick}
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100vh',
                    bgcolor: 'rgba(0, 0, 0, 0.5)',
                    p: 2
                }}
            >
                <Box
                    onClick={(e) => e.stopPropagation()} // Prevent closing modal when clicking inside this box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        width: '100%',
                        maxWidth: 300,
                        bgcolor: 'background.paper',
                        p: 4,
                        borderRadius: 2
                    }}
                >
                    כרטיס לקוח {customer?.name}
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        onClick={(e) => {
                            handleNavigate(customer.id, 'delivery_certificate');
                        }}
                    >
                        תעודות חדשה
                    </Button>
                    <Button
                        variant="contained"
                        color="success"
                        size="large"
                        onClick={(e) => {
                            handleNavigate(customer.id, 'invoice');
                        }}
                    >
                        חשבוניות מוצרים
                    </Button>
                    <Button
                        variant="contained"
                        size="large"
                        onClick={(e) => {
                            const d = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
                            handleNavigate(customer.id, 'order',dateObjectToString(d));
                        }}
                    >
                        הזמנה
                    </Button>
                    <Button variant="contained"  size="large"  onClick={(e) => {
                        navigate(`/customer/documents/all-documents?id=${id}`);
                    }}>
                        מסמכים
                    </Button>

                    <Button variant="contained" onClick={(e)=>{
                        handleNavigateToPricesList(customer.id);
                    }} sx={{ color: 'grey' }} size="large">
                        מחירי מוצרים
                    </Button>
                    <Button variant="contained" onClick={() => setKartesetOpen(true)} size="large">
                        כרטסת
                    </Button>

                    <Button variant="contained" onClick={handlePrivateInfoClick} sx={{ color: 'grey' }} size="large">
                        פרטים אישיים
                    </Button>
                    <Button variant="contained" disabled={true} size="large">
                        פעולות
                    </Button>
                </Box>
            </Box>
            <AddCustomer
                open={customerAction.open}
                handleDrawerOpen={handleDrawerClose}
                id={customerAction.id}
                editable={customerAction.editable}
                setPreviewOpen={false}
                branches={branches}
            />
            {kartesetOpen && (
                <Modal open={kartesetOpen} onClose={() => setKartesetOpen(false)} sx={{zIndex: 3000}}>
                    <Box sx={{ width: '100vw', height: '100vh' }}>
                        <KartesetMobile id={customer?.id} fullScreen={true} onClose={() => setKartesetOpen(false)} />
                    </Box>
                </Modal>
            )}
        </>
    );
};

export default CustomerActionsView2;
